import React from 'react';
import SettingsGridWrapper from '../../../../../components/Dashboard/settings/ui/SettingsGridWrapper';
import SettingsSectionHeader from '../../../../../components/Dashboard/settings/ui/SettingsSectionHeader';
import VerifiedBusinessBadge from '../../../../../components/Dashboard/settings/business-verification/VerifiedBusinessBadge';
import SettingsMainContentWrapper from '../../../../../components/Dashboard/settings/ui/SettingsMainContentWrapper';
import DashboardSubheader from '../../../../../components/Dashboard/DashboardSubheader';
import VerificationStatus from '../../../../../components/Dashboard/settings/business-verification/VerificationStatus';
import RequiredDocCard from '../../../../../components/Dashboard/settings/business-verification/RequiredDocCard';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store/store';
import EmptyPage from '../../../../../components/ui/EmptyPage';
import { IonicButton } from 'ionic-ui';
import { Link } from 'react-router-dom';

export default function BusinessVerificationPage() {
  const userProfile = useSelector((state: RootState) => state.userProfile);
  return (
    <SettingsGridWrapper>
      <div className="space-y-6">
        <SettingsSectionHeader
          header="Business Verification"
          subheader="Manage your account preferences and security settings."
        />
        <VerifiedBusinessBadge
          isVerified={userProfile?.verification_progress.completed}
        />
      </div>
      <SettingsMainContentWrapper className="space-y-4">
        <DashboardSubheader>Required Documents</DashboardSubheader>

        {/* UPLOADED FILES WRAPPER */}
        {userProfile?.verification_documents?.length ? (
          <div className="space-y-2">
            {userProfile?.verification_documents?.map(
              ({ id, name, meta_info, verification_status }, idx) => (
                <RequiredDocCard
                  filePurpose={name}
                  key={`${id}-${idx}`}
                  status={verification_status}
                  fileName={meta_info.document_name}
                />
              )
            )}
          </div>
        ) : (
          <EmptyPage className="h-[40vh]" message="No documents uploaded yet.">
            <Link to="/dashboard/get-started/">
              <IonicButton type="button" variant="ghost" size="lg">
                Upload document
              </IonicButton>
            </Link>
          </EmptyPage>
        )}

        {userProfile?.verification_progress.completed && (
          <VerificationStatus status="approved" />
        )}
      </SettingsMainContentWrapper>
      {/* <SettingsActionButtons /> */}
    </SettingsGridWrapper>
  );
}
